export const LOAD_SERVICES = 'services/LOAD_SERVICES';
export const LOAD_SERVICES_SUCCESS = 'services/LOAD_SERVICES_SUCCESS';
export const LOAD_SERVICES_ERROR = 'services/LOAD_SERVICES_ERROR';
export const SAVE_SERVICE_REQUEST = 'services/SAVE_SERVICE_REQUEST';
export const SAVE_PRINT_MATERIAL_REQUEST = 'services/SAVE_PRINT_MATERIAL_REQUEST';
export const REMOVE_PRINT_MATERIAL_REQUEST =
  'services/REMOVE_PRINT_MATERIAL_REQUEST';
